function bind( el, binding, vnode, oldVnode) {
    
    const callback = function (event) {
        el.previousValue = el.checked;
    }
    const callback2 = () =>{
        if (el.previousValue) {
            el.checked = false;
        }
    }
    el.addEventListener('mousedown', callback)
    el.addEventListener('click', callback2)
    el._onMousedown = callback
    el._onClick= callback2
    
}
function unbind(el) {
    const { callback } = el._onMousedown
    const { callback2 } = el._onClick
    window.removeEventListener('mousedown', callback)
    window.removeEventListener('click', callback2)
    delete el._onMousedown
    delete el._onClick
}
export default {
    name: 'radio',
    bind,
    unbind
}